import internalApiClient from '../util/api/internalApiClient';

interface RenderProps {
    mutate: (data?: any) => Promise<any>;
}

interface Props {
    children: (props: RenderProps) => React.ReactNode | any;
    method?: string;
    url: string;
}

export default function Mutation({ children, method = 'post', url }: Props) {
    const mutate = data => internalApiClient[method.toLowerCase()](url, data);
    return children({ mutate });
}

type MutationResult = (data: any) => Promise<any>;

export const useMutation = (url: string, method: 'POST' | 'PUT' | 'PATCH' | 'DELETE' = 'POST'): MutationResult => {
    return (data?: any) => internalApiClient[method.toLowerCase()](url, data);
};
